const parseJsonValue = (value, fallback) => {
  if (!value) return fallback;
  if (typeof value !== "string") return value;

  try {
    return JSON.parse(value);
  } catch {
    return fallback;
  }
};

const findMatchingLine = (lines, item, itemIndex) => {
  if (!Array.isArray(lines)) return null;

  return (
    lines.find(
      (line) =>
        Number(line?.order_item_id) === Number(item?.order_item_id)
    ) || lines[itemIndex] || null
  );
};

export const getOrderItemTaxDetails = (order, item, itemIndex) => {
  const invoice = order?.invoice || {};
  const invoiceItems = parseJsonValue(invoice.items, []);
  const taxSnapshot = parseJsonValue(invoice.tax_snapshot, {});
  const snapshotItems = Array.isArray(taxSnapshot?.items)
    ? taxSnapshot.items
    : [];
  const invoiceLine = findMatchingLine(invoiceItems, item, itemIndex);
  const tax =
    invoiceLine?.tax ||
    findMatchingLine(snapshotItems, item, itemIndex) ||
    null;
  const orderProduct = parseJsonValue(item?.product_snapshot, {});
  const invoiceProduct = parseJsonValue(invoiceLine?.product_snapshot, {});
  const hsnSacCode =
    tax?.hsn_sac_code ||
    invoiceLine?.hsn_sac_code ||
    invoiceProduct?.hsn_sac_code ||
    orderProduct?.hsn_sac_code ||
    null;

  const hasTaxData = Boolean(
    tax &&
      [
        tax.gst_percentage,
        tax.taxable_amount,
        tax.tax_amount,
        tax.cgst_amount,
        tax.sgst_amount,
        tax.igst_amount,
      ].some((value) => value !== undefined && value !== null)
  );

  return {
    tax,
    hsnSacCode,
    taxType: invoice.tax_type || taxSnapshot.tax_type || null,
    hasTaxData,
  };
};
